import { ShopifyProvider } from '@shopify/hydrogen-react';
import { useCountry } from '@backpackjs/storefront';

import { useShopifyAnalytics } from './useShopifyAnalytics';

function ShopifyAnalyticsTracker({ collection, product }) {
  useShopifyAnalytics({ collection, product });
  return null;
}

export function ShopifyAnalyticsBoundary({ children, collection, product }) {
  const { country } = useCountry();
  const storeDomain = process.env.SHOPIFY_DOMAIN;
  const storefrontToken = process.env.SHOPIFY_STOREFRONT_API_TOKEN;
  const storefrontApiVersion =
    process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION ||
    process.env.SHOPIFY_STOREFRONT_API_VERSION ||
    '2025-10';

  if (!storeDomain || !storefrontToken || !storefrontApiVersion) {
    return children;
  }

  return (
    <ShopifyProvider
      storeDomain={storeDomain}
      storefrontToken={storefrontToken}
      storefrontApiVersion={storefrontApiVersion}
      sameDomainForStorefrontApi
      countryIsoCode={country?.isoCode || 'US'}
      languageIsoCode="EN"
    >
      <ShopifyAnalyticsTracker collection={collection} product={product} />
      {children}
    </ShopifyProvider>
  );
}
